module.exports = __webpack_public_path__ + "static/img/12.0f7d775.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/eng/12.png
// module id = 2bAR
// module chunks = 0